import { SideCancelBtn, SubmitBtn } from "../Styles/InputStyles";
import Model from "../Model";
import tw from "tailwind-styled-components";

const RemainderAll = ({
    setIsRemainderAll,
    sendReminderLoading,
    sendReminderMutate,
}) => {

    const handleSubmit = ({ setSubmitting }) => {
        sendReminderMutate({
            tenantId: 0,
        });
    };

    return (
        <Model
            width={"w-full max-w-md"}
            setOpenModel={setIsRemainderAll}
            title="Send Reminder"
        >
            <WarningText>
                This will send a payment reminder to all tenants.
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4">
                <SideCancelBtn type="button" onClick={() => setIsRemainderAll(false)}>
                    Cancel
                </SideCancelBtn>
                <SubmitBtn
                    type="submit"
                    disabled={sendReminderLoading}
                    onClick={handleSubmit}
                >
                    {sendReminderLoading ? "Reminding..." : "Remind All"}
                </SubmitBtn>
            </div>
        </Model>
    );
};
const WarningText = tw.p`text-gray-500 text-base mb-4`;
export default RemainderAll;